// extracted by mini-css-extract-plugin
export var bubble = "_3u-0";
export var container = "_3u-f";
export var contrastBorder = "_3u-g";
export var greyOut = "_3u-2";
export var initialsColor0 = "_3u-3";
export var initialsColor1 = "_3u-4";
export var initialsColor10 = "_3u-d";
export var initialsColor11 = "_3u-e";
export var initialsColor2 = "_3u-5";
export var initialsColor3 = "_3u-6";
export var initialsColor4 = "_3u-7";
export var initialsColor5 = "_3u-8";
export var initialsColor6 = "_3u-9";
export var initialsColor7 = "_3u-a";
export var initialsColor8 = "_3u-b";
export var initialsColor9 = "_3u-c";
export var initialsWrapper = "_3u-1";
export var large = "_3u-l";
export var medium = "_3u-k";
export var mediumSmall = "_3u-j";
export var mediumSmallMedium = "_3u-o";
export var micro = "_3u-h";
export var small = "_3u-i";
export var tiny = "_3u-n";
export var xTiny = "_3u-m";